// apps/client/src/assets/builders/mailbox.ts — the look demo's post mailbox (town.ts mailbox(color, flagUp)), in the owner's friend dye.
// Params { color: string; flag: boolean }: with kit houses the mailbox is where the friend colour sits on the plot (revision 10);
// M1-T17 raises the flag for unread mail.
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';

const CREAM = '#FFF4E2';
export const builder: CodeBuilder = {
  id: 'mailbox',
  build(p) {
    const color = typeof p.color === 'string' && /^#[0-9a-f]{6}$/i.test(p.color) ? p.color : CREAM;
    const g = new THREE.Group();
    const part = (geo: THREE.BufferGeometry, hex: string, x: number, y: number, z: number, parent: THREE.Object3D = g) => {
      const m = new THREE.Mesh(geo, toyMaterial(hex));
      m.position.set(x, y, z);
      m.castShadow = m.receiveShadow = true;
      parent.add(m);
      return m;
    };
    part(new RoundedBoxGeometry(0.13, 1.0, 0.13, 2, 0.03), '#8A6A4F', 0, 0.5, 0);
    part(new RoundedBoxGeometry(0.42, 0.36, 0.62, 3, 0.15), color, 0, 1.12, 0.06);
    part(new RoundedBoxGeometry(0.34, 0.26, 0.04, 2, 0.02), '#4A3A2C', 0, 1.1, 0.375);
    const flag = new THREE.Group();
    flag.name = 'flag';
    flag.position.set(0.23, 1.0, -0.05);
    part(new RoundedBoxGeometry(0.035, 0.42, 0.035, 2, 0.01), '#B33A26', 0, 0.21, 0, flag);
    part(new RoundedBoxGeometry(0.03, 0.15, 0.2, 2, 0.01), '#E0503A', 0, 0.36, 0.1, flag);
    flag.rotation.x = p.flag === true ? 0 : Math.PI / 2;
    g.add(flag);
    return g;
  },
};
